<div id="admissions-fees" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Fees & Scholarships</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College, Sirsa offers affordable education with a transparent fee structure. The college
      also facilitates various Government scholarships to support meritorious and economically weaker students.
    </p>
    <hr class="divider">
    <h4 class="section-subtitle">Fee Structure 2026–27</h4>
    <div class="pdf-block">
      <pdf-viewer src="/assets/pdf/admission/fee structure 26-27.pdf" [render-text]="true" [original-size]="false"
        style="width:100%; height:680px; display:block;"></pdf-viewer>
    </div>
    <div class="mt-4 d-flex flex-wrap gap-3 justify-content-center">
      <a href="/assets/pdf/admission/fee structure 26-27.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download"></i> Download Fee Structure 2026–27 (Latest)
      </a>
      <a href="/assets/pdf/admission/Fee-Structure-25-26.-updated-1.pdf" target="_blank"
        class="pdf-download-btn outline-btn">
        <i class="fa fa-download"></i> Download Fee Structure 2025–26
      </a>
    </div>
    <!-- <hr class="divider">
    <h4 class="section-subtitle">Scholarships Available</h4>
    <ul class="inner-lead">
      <li><strong>Haryana State Scholarship</strong> — For SC/ST/OBC and economically weaker students</li>
      <li><strong>Central Sector Scholarship</strong> — For meritorious students (Ministry of Education)</li>
      <li><strong>Post Matric Scholarship</strong> — Government of Haryana for reserved categories</li>
      <li><strong>Begum Hazrat Mahal National Scholarship</strong> — For minority girl students</li>
      <li><strong>NSP Portal Scholarships</strong> — National Scholarship Portal — various schemes</li>
    </ul>
    <div class="mt-3">
      <a href="/assets/pdf/admissions/scholarship-links.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download"></i> Scholarship Links & Details
      </a>
    </div> -->
  </div>
</div>